import React, { useState } from "react";
import "../../components/AboutTimeLine/AboutTimeLine.css"; 
import aboutImages from '../../assets/images/4.png';
import aboutImages1 from '../../assets/images/3.png';
import aboutImg1 from '../../assets/images/one2.png';
import aboutImg2 from '../../assets/images/one3.png';
import aboutImg3 from '../../assets/images/one4.png';
import aboutImg5 from '../../assets/images/one5.png';
import aboutImg6 from '../../assets/images/one6.png';
import aboutImg7 from '../../assets/images/one7.png';
import aboutImgs1 from '../../assets/images/4.3.png';
import aboutImgs2 from '../../assets/images/4.4.png';
import aboutImgs3 from '../../assets/images/4.5.png';
import aboutImgs4 from '../../assets/images/4.6.png';
import aboutImgs5 from '../../assets/images/4.7.png';
import aboutImgs6 from '../../assets/images/4.8.png';
import aboutIm1 from '../../assets/images/5.3.png';
import aboutIm2 from '../../assets/images/5.4.png';
import aboutIm3 from '../../assets/images/5.5.png';
import aboutIm4 from '../../assets/images/5.6.png';
import aboutI from '../../assets/images/6.3.png';
import aboutI2 from '../../assets/images/6.4.png';
import aboutimgg from '../../assets/images/timeline4.png';
import aboutimgg1 from '../../assets/images/timeline4.png';
import aboutimgg2 from '../../assets/images/timeline4.2.png';
import aboutimgg3 from '../../assets/images/7.8.png';
import aboutimg4 from '../../assets/images/6.4.png';
import aboutimg5 from '../../assets/images/7.5.png';
import aboutimg6 from '../../assets/images/7.6.png';
import aboutimg7 from '../../assets/images/7.7.png';
import aboutimg8 from '../../assets/images/7.8.png';
import aboutimg9 from '../../assets/images/7.3.png';
import aboutimg10 from '../../assets/images/7.4.png';
import aboutImages2 from '../../assets/images/timeline1.png';
import aboutImages22 from '../../assets/images/timeline1.1.png';
import aboutImages3 from '../../assets/images/timeline2.png';
import aboutImages33 from '../../assets/images/timeline2.1.png';
import aboutImages4 from '../../assets/images/timeline3.png';
import aboutImages44 from '../../assets/images/timeline3.2.png';


const AboutTimeline = () => {
  const timelineData = {
    pre: [
      {
        year: "1875",
        content: {
          title: "1875",
          text: "Bengal Iron Works was founded, marking the beginning of steel production in India.",
          image1: aboutImages,
          image2: aboutImages1
        }
      },
      {
        year: "1907",
        content: {
          title: "1907",
          text: "Tata Steel (TISCO) was established by Jamsetji Tata, laying the foundation for large-scale steel production.",
          image1: aboutImg2,
          image2: aboutImg1
        }
      },
      {
        year: "1923",
        content: {
          title: "1923",
          text: " The Indian Iron and Steel Company (IISCO) was set up.",
          image1: aboutImg5,
          image2: aboutImg3
        }
      },
      {
        year: "1937",
        content: {
          title: "1937",
          text: " Mysore Iron and Steel Works (later Visvesvaraya Iron & Steel) founded.",
          image1: aboutImg7,
          image2: aboutImg6
        }
      },

    ],
    post: [
      {
        year: "1954",
        content: {
          title: "1954",
          text: "Hindustan Steel Limited (HSL) formed to develop public-sector steel plants.",
          image1: aboutImages22,
          image2: aboutImages2
        }
      },
      {
        year: "1956–1962",
        content: {
          title: "1956–1962",
          text: " Three integrated steel plants set up at Bhilai, Rourkela, and Durgapur.",
          image1: aboutImgs2,
          image2: aboutImgs1
        }
      },
      {
        year: "1973",
        content: {
          title: "1973",
          text: " Steel Authority of India Limited (SAIL) established to manage public-sector steel plants.",
          image1: aboutImgs4,
          image2: aboutImgs3
        }
      },
      {
        year: "1980s ",
        content: {
          title: "1980s ",
          text: " Growth in public-sector steel production, but inefficiencies remained.",
          image1: aboutImgs6,
          image2: aboutImgs5
        }
      }
    ],
    liberal: [
      {
        year: "1991",
        content: {
          title: "1991",
          text: " Economic liberalization allows private players like JSW Steel, Essar Steel, and Jindal Steel and Power to emerge.",
          image1: aboutImages33,
          image2: aboutImages3
        }
      },
      {
        year: "2005",
        content: {
          title: "2005",
          text: "India becomes the 7th largest crude steel producer globally.",
          image1: aboutIm2,
          image2: aboutIm1
        }
      },
      {
        year: "2008–2010",
        content: {
          title: "2008–2010",
          text: "– Increased foreign investments and modernization efforts.",
          image1: aboutIm4,
          image2: aboutIm3
        }
      }
    ],
    expansion: [
      {
        year: "2017",
        content: {
          title: "2017",
          text: " India surpasses Japan to become the 2nd largest crude steel producer in the world.",
          image1: aboutImages44,
          image2: aboutImages4
        }
      },
      {
        year: "2019",
        content: {
          title: "2019",
          text: " The National Steel Policy 2017 targets 300 million tonnes of steel production by 2030.",
          image1: aboutI2,
          image2: aboutI
        }
      }
    ],
    sustainability: [
      {
        year: "2021",
        content: {
          title: "2021",
          text: "Focus shifts towards green steel and decarbonization to meet climate goals.",
          image1: aboutimgg2,
          image2: aboutimgg
        }
      },
      {
        year: "2022",
        content: {
          title: "2022",
          text: " India produces 124.7 million tonnes of crude steel despite global economic challenges.",
          image1: aboutimg10,
          image2: aboutimg9
        }
      },
      {
        year: "2023",
        content: {
          title: "2023",
          text: " Expansion of digitalization in steel manufacturing, with AI and automation playing key roles.",
          image1: aboutimg6,
          image2: aboutimg5
        }
      },
      {
        year: "2024",
        content: {
          title: "2024",
          text: " Increased investment in hydrogen-based steelmaking and circular economy initiatives.",
          image1: aboutimg8,
          image2: aboutimg7
        }

      },

    ]
  };

  const [currentEra, setCurrentEra] = useState("pre"); // Default era
  const [currentEvents, setCurrentEvents] = useState(timelineData.pre); // Default events for "pre" era
  const [currentEventIndex, setCurrentEventIndex] = useState(0); // Default to the first event

  const handleTabClick = (era) => {
    setCurrentEra(era);
    setCurrentEvents(timelineData[era]);
    setCurrentEventIndex(0);
  };

  const handleMarkerClick = (index) => {
    setCurrentEventIndex(index);
  };

  const renderTimelineMarkers = () => {
    return currentEvents.map((event, index) => (
      <div
        className={`timeline-marker ${index === currentEventIndex ? "active" : ""}`}
        key={index}
        onClick={() => handleMarkerClick(index)}
        data-year={event.year}
      >
        <div className="frame-wrapper-2">
          <div className="div-4"></div>
        </div>
        <div className="div-wrapper-2">
          <div className="text-wrapper-2">{event.year}</div>
        </div>
      </div>
    ));
  };

  const renderEventContent = () => {
    const event = currentEvents[currentEventIndex].content;
    return (
      <div className="timeline-event-content">
        <div className="event-details">
          <div className="event-title font-poppins">{event.title}</div>
          <p className="event-text font-poppins">{event.text}</p>
          <img className="event-images" src={event.image2} alt={event.title} />

        </div>
        <div className="images-container">
          <img className="event-image" src={event.image1} alt={event.title} />
        </div>
      </div>
    );
  };
  

  return (
    <div className="frame custom-container-upper ">
      <div className="evolution-of-the-wrapper">
        <p className="evolution-of-the font-merriweather ">Evolution Of The Indian Steel Industry</p>
      </div>

      <div className="component custom-inner-space">
        <div className="tabs">
          {["pre", "post", "liberal", "expansion", "sustainability"].map((era) => (
            <div
              className={`tab ${currentEra === era ? "active" : ""}`}
              key={era}
              onClick={() => handleTabClick(era)}
            >
              <div className="component-2 font-merriweather">
                <div className={`div-wrapper ${era}`} style={{ whiteSpace: 'nowrap' }}>
                  {era === "pre" && "Pre-independence Era (before 1947)"}
                  {era === "post" && "Post-independence And Industrialization"}
                  {era === "liberal" && "Liberalization And Growth (1991–2010)"}
                  {era === "expansion" && "Expansion And Modernization (2011–2020)"}
                  {era === "sustainability" && "Sustainability And Technological Advancements (2021-2024)"}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="component-4">
          <div className="timeline-markers">{renderTimelineMarkers()}</div>
          <div className="timeline-event-content" style={{ display: currentEvents[currentEventIndex] ? 'flex' : 'none' }}>
            {renderEventContent()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutTimeline;
